export const DEFAULT_PROPS = {
  size: 'sm',
} as const;
